import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// ========== PARTS ==========
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== SCSS ==========
import '../scss/login.scss';

export class Login extends Component {
  handleChange(e) {
    const value = e.target.value;
    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  handleCheckBoxChange(e) {
    this.setState({
      save_local: e.target.checked
    })
  }

  async formSubmit(e) {
    e.preventDefault();

    let response = await window.doRequest('POST', {
      action: 'login',
      email: this.state.email,
      password: this.state.password
    });

    // save auth token
    if (response.status) {

      sessionStorage.setItem('token', response.content.token);
      sessionStorage.setItem('is_admin', response.content.is_admin);

      window.utils.tokken = response.content.token;
      window.utils.logged = true;
      
      this.props.history.push('/states');

    } else {
      window.alert(response.message);
    }
  }

  componentDidMount() {
    if (window.utils.logged)
      this.props.history.push('/states');
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="login">
          <div className="container">
            <div className="row">
              <div className="column">
                <h2>Repositório</h2>
                <p>Biblioteca digital do projeto regionalização cujo o objetivo é garantir o armazenamento, preservação e disponibilização de relatórios e documentos da equipe do projeto.</p>
              </div>
              <div className="column">
                <h1 className="title">Acesso Restrito</h1>
                <form onSubmit={(e) => { this.formSubmit(e) }}>
                  <input type="mail" placeholder="E-mail" name="email" onChange={(e) => {this.handleChange(e)}} required/>
                  <input type="password" placeholder="Senha" name="password" onChange={(e) => {this.handleChange(e)}} required/>
                  <button type="submit" className="btn filled">Entrar</button>
                  <Link to="/recover">Esqueceu a senha?</Link>
                </form>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default Login
